import { render, staticRenderFns } from "./EditLifeInfo.vue?vue&type=template&id=53e573ae"
import script from "./EditLifeInfo.vue?vue&type=script&lang=js"
export * from "./EditLifeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports